module.exports = __webpack_public_path__ + "img/07.8166e7a4.png";